import {  useQuery } from "react-query";
import instance from '../services/api'; 
/*import * as msal from "@azure/msal-browser"; 

const msalConfig = {
    auth: {
      clientId: process.env.REACT_APP_DEV_CLIENT_ID,
      authority: `https://login.microsoftonline.com/${process.env.REACT_APP_DEV_TENANT_ID}`,
      protocolMode: "OIDC"
  }
}
*/
//var authToken = "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6IjJaUXBKM1VwYmpBWVhZR2FYRUpsOGxWMFRPSSIsImtpZCI6IjJaUXBKM1VwYmpBWVhZR2FYRUpsOGxWMFRPSSJ9.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTBmZjEtY2UwMC0wMDAwMDAwMDAwMDAvb3BlbnN5c3RlbXMxMzEuc2hhcmVwb2ludC5jb21AOWMxY2Q5MDktYTgwMy00Mzg4LWI1Y2MtYTg4NjkyYjU5NTcxIiwiaXNzIjoiMDAwMDAwMDEtMDAwMC0wMDAwLWMwMDAtMDAwMDAwMDAwMDAwQDljMWNkOTA5LWE4MDMtNDM4OC1iNWNjLWE4ODY5MmI1OTU3MSIsImlhdCI6MTY2MzA0MTM2MywibmJmIjoxNjYzMDQxMzYzLCJleHAiOjE2NjMxMjgwNjMsImlkZW50aXR5cHJvdmlkZXIiOiIwMDAwMDAwMS0wMDAwLTAwMDAtYzAwMC0wMDAwMDAwMDAwMDBAOWMxY2Q5MDktYTgwMy00Mzg4LWI1Y2MtYTg4NjkyYjU5NTcxIiwibmFtZWlkIjoiZWMzMDczODAtNTc4OC00OTNkLTgyM2YtNzA0N2QyOTM3ZGVhQDljMWNkOTA5LWE4MDMtNDM4OC1iNWNjLWE4ODY5MmI1OTU3MSIsIm9pZCI6IjI5MzVlZTZlLTI5MzctNDVlYy1iZGI1LTBjZGU4ZGFhNGVmMiIsInN1YiI6IjI5MzVlZTZlLTI5MzctNDVlYy1iZGI1LTBjZGU4ZGFhNGVmMiIsInRydXN0ZWRmb3JkZWxlZ2F0aW9uIjoiZmFsc2UifQ.hj1uxEuC_BQ7cFsFzE_jsO5cM4pvycXQb338t04RCQx71aETkwkKahB1NDu8wtAVeBLVGhFqBIgU4GBrjbOpSWJltIhIK6zyowdXVzdmMPQ9B4gVSXHsTfKMkBnTjydyYKvmgyZCx94rjg9XCj1Bh91L4UlSAumu2NR-BJhjAEBJJYYla_UoLziEahhVDniGYdtX0TXrOpT5ul7CRhKri3dTU90mGtKFml2AwykqzEncL-MJRgMDIQLeoMiPPYlzzKOPsc4vuSwktbARg9-ssSoPWqEjnkxYu4ootZdSOzpDnAByjuEb204GvHLV0HfAkEWzLspOY2p9-lucN2k98A";
//var siteURL = "https://opensystems131.sharepoint.com/sites/PaulsTestSite";
 /*
var getAuthTokenBody = {"grant_type":"client_credentials","client_id":`ec307380-5788-493d-823f-7047d2937dea@9c1cd909-a803-4388-b5cc-a88692b59571`,
"client_secret":`4Rmzt0yfNgCY8oJWehg4Q+LZQlFCNaiI09Qmod7j1Qo=`,
"resource":`00000003-0000-0ff1-ce00-000000000000/opensystems131.sharepoint.com@9c1cd909-a803-4388-b5cc-a88692b59571`}
 */
// BELOW IS GRAPH AUTH body attempt
/*
var getAuthTokenBody = {"grant_type":"client_credentials","client_id":`ec307380-5788-493d-823f-7047d2937dea`, 
"scope":"https://graph.microsoft.com/.default",
"client_secret":"4Rmzt0yfNgCY8oJWehg4Q+LZQlFCNaiI09Qmod7j1Qo="};
*/


export const useFolders = (ServerRelativeUrl) => {
  return useQuery(["folders", ServerRelativeUrl], 
  async () => {
   const { data } = await instance
   .get(`/_api/Web/GetFolderByServerRelativePath(decodedurl='${ServerRelativeUrl}')/folders?$orderBy=name`)
   .catch((error) => {
        console.log(error);
   });  
 
    return data;
 
 },
// This tells React-Query that this is Query is part of
  // a paginated component
  { keepPreviousData: true }
);
};

/*export const useFolders = (ServerRelativeUrl, authToken) => {
 return useQuery(["folders", ServerRelativeUrl], 
 async () => {
  const { data } = await axios.get(`${process.env.REACT_APP_PROD_API_URL}/_api/Web/GetFolderByServerRelativePath(decodedurl='${ServerRelativeUrl}')/folders?$orderBy=name`, {headers:{
   "Accept": "application/json;odata=verbose",
   "Authorization": `Bearer ${authToken}`
  }}).catch((error) => {
       console.log(error);
  });  

   return data;

},
  // This tells React-Query that this is Query is part of
  // a paginated component
  { keepPreviousData: true }
);
};*/